module.exports = __webpack_public_path__ + "img/sz.59e2dbc.svg";